module.exports = __webpack_public_path__ + "static/img/yixi_mini.4f58c201.png";